"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIProvideQueueActions = void 0;
function isIProvideQueueActions(value) {
    if (typeof value.getQueueActions !== "function") {
        return false;
    }
    return true;
}
exports.isIProvideQueueActions = isIProvideQueueActions;
//# sourceMappingURL=IProvideQueueActions.js.map